import List from '@utils/list'
const { Search, Table, Jurisdiction } = List
import dateUtil from 'element-ui/src/utils/date.js'

const jurisdiction = new Jurisdiction()
  .lib('manual').access('/sysQuartzJob/runCheckReturnJob', process.env.VUE_APP_SCHEDULE_API)

const search = new Search('inventoryCollaboration.query')
  .placeholder('searchPlaceholder')
  .add('orderType').op('orderType')
  .add('purchaseNo')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')

const table = new Table('inventoryCollaboration.query')
  .add('docDate').format(({ value }) => dateUtil.format(new Date(value), 'yyyy-MM-dd'))
  .add('purOfficeName')
  .add('supOfficeName')
  .add('orderType').op('orderType')
  .add('sourceNo')
  .add('sourceSeq')
  .add('purchaseNo').width(160)
  .add('purchaseSeq')
  .add('purchaseLineSeq')
  .add('goodsNo').width(160)
  .add('goodsName')
  .add('spec')
  .add('stockQty')
  .add('purUnitName')
  .add('valuationQty')
  .add('valuationUnitName')
  .add('unitPrice')
  .add('taxIncludedAmount')
  .add('taxAmount')
  .add('taxTypeName')
  .add('taxRate')
  .add('currencyName')
  .add('payTermsName')
  .add('dataSource').format(({ value }) => value === 1 ? 'erp' : 'srm')

export default new List()
  .url('/srmCost/getWarehousingPage', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .search(search)
  .table(table)
  .end()
